import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NasModelModule } from '@sama/ng-app-state';
import { SamaScrollSectionNavigationModule } from '@sama/ui-library';
import { ImageContentModule } from '../../../2d/image-content/image-content.module';
import { CvFeedbackPanelComponent } from '../../../core/feedback/views/cv-feedback-panel/cv-feedback-panel.component';
import { RasterCodingHelpModalComponent } from '../../../core/outputs/annotation/annotation-shared/toolbars/static-toolbar/help-modal/raster-coding-help-modal.component';
import { VectorTaggingHelpModalComponent } from '../../../core/outputs/annotation/annotation-shared/toolbars/static-toolbar/help-modal/vector-tagging-help-modal.component';
import { TagOptionListComponent } from '../../../core/outputs/annotation/image-annotation/toolbars/tag-option-list/tag-option-list.component';
import { CrossTeamSharedModule } from '../../../cross-team-shared/cross-team-shared.module';
import { SharedModule } from '../../../shared/shared.module';
import { AnnotationSharedModule } from '../annotation-shared/annotation-shared.module';
import { ImageAnnotationOutputComponent } from './image-annotation-output.component';
import { ImageAnnotationLayoutComponent } from './layout/image-annotation-layout.component';
import { RasterCodingToolbarsComponent } from './layout/raster-coding-toolbars.component';
import { VectorTaggingShapeListAndTagEditorComponent } from './layout/vector-tagging-shape-list-and-tag-editor.component';
import { VectorTaggingToolbarsComponent } from './layout/vector-tagging-toolbars.component';

@NgModule({
  imports: [
    AnnotationSharedModule,
    CommonModule,
    CrossTeamSharedModule,
    CvFeedbackPanelComponent,
    FontAwesomeModule,
    FormsModule,
    ImageContentModule,
    MatButtonModule,
    MatDialogModule,
    MatTabsModule,
    NasModelModule,
    SamaScrollSectionNavigationModule,
    SharedModule,
  ],
  declarations: [
    ImageAnnotationOutputComponent,
    ImageAnnotationLayoutComponent,
    TagOptionListComponent,
    RasterCodingHelpModalComponent,
    RasterCodingToolbarsComponent,
    VectorTaggingHelpModalComponent,
    VectorTaggingToolbarsComponent,
    VectorTaggingShapeListAndTagEditorComponent,
  ],
  exports: [ImageAnnotationOutputComponent],
})
export class ImageAnnotationModule {}
